module.exports = __webpack_public_path__ + "static/media/logo_big.695bf5d3.png";